import axios from "axios";

export const getAdminToken = ()=> {
  return localStorage.getItem("TOKEN_LOGIN_ADMIN");
};

const boRequester = axios.create({
  baseURL: process.env.REACT_APP_BASE_BO_API,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
boRequester.interceptors.request.use(async (config) => {
  const accessToken = getAdminToken();
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  } else {
    config.headers.Authorization = undefined;
  }
  return config;
});
// Add a response interceptor
boRequester.interceptors.response.use(
  function (response: {
    data: { status: string; output: string; cause: string };
  }) {
    if (response?.data?.status === "FAILED") {
      let message = response.data?.cause;
      try {
        const errorData = JSON.parse(response.data?.cause);
        if (errorData?.errorMessage) {
          message = errorData?.errorMessage;
        }
      } catch (error) {
        console.log(error);
      }
      return Promise.reject({ error: true, message });
    }
    if (response?.data?.output) {
      response.data = JSON.parse(response.data.output);
    }
    return Promise.resolve(response.data);
  },
  function (error) {
    if (error.response) {
      error.status = error.response.status;
      error.message = error.response.statusText;
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.documentRequest in node.js
      // console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      // console.log('Error', error.message);
    }
    console.log(error);
    if (error?.status && error.status === 401) {
      // removeToken();
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default boRequester;
